import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Lesson from "./Pages/Lesson";
import ForYouMySoul from "./Pages/ForYouMySoul";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import PrivateRoute from "./PrivateRoute";
import "./App.css";

function App() {
  return (
    <Router>
      <nav>
        {/* <Link to="/">Home</Link> */}
        <Link to="/lesson">Lessons</Link> |
        <Link to="/for-you-my-soul"> For You, My Soul! </Link> |
        <Link to="/login">Login</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lesson" element={<Lesson />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/for-you-my-soul"
          element={
            <PrivateRoute>
              <ForYouMySoul />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
